import { ScrapedPet } from '../../../models/pet.model';
import { PetDTO } from './pet.model';

// Light transformer between wire and domain: coerces nullable strings the FE
// treats as always-present, and renames `updated` to `scrapedAt`. Everything
// else is a pass-through — wire enum values arrive already lowercase-kebab
// per AB#1741.
export function petDtoToScrapedPet(dto: PetDTO): ScrapedPet {
  return {
    id: dto.id,
    sourceId: dto.sourceId,
    sourceUrl: dto.sourceUrl,
    source: '',
    sourceDisplayName: dto.sourceDisplayName ?? '',
    species: dto.species ?? '',
    name: dto.name ?? '',
    breed: dto.breed,
    ageLabel: dto.ageLabel,
    ageMonths: dto.ageMonths,
    sex: dto.sex,
    size: dto.size,
    imageUrl: dto.imageUrl ?? '',
    canLiveInFlat: dto.canLiveInFlat,
    requiresGarden: dto.requiresGarden,
    canLiveWithChildren: dto.canLiveWithChildren,
    canLiveWithDogs: dto.canLiveWithDogs,
    canLiveWithCats: dto.canLiveWithCats,
    canLiveWithPets: dto.canLiveWithPets,
    canBeLeftAlone: dto.canBeLeftAlone,
    trainingStatus: dto.trainingStatus,
    adoptionStatus: dto.adoptionStatus,
    scrapedAt: dto.updated,
  };
}
